export const queryKeys = {
  CLIENT_COMPANIES: "clientCompanies",
  DASHBOARD: "dashboard",
  AD_GROUPS: "adGroups",
  AD_GROUP_PRODUCT_MAPPINGS: "adGroupProductMappings",
  AD_GROUP_ROLE_MAPPINGS: "adGroupRoleMappings",
  AD_GROUP_SYNC_PREVIEW: "adGroupSyncPreview",
  AD_GROUP_SYNC_CANDIDATE_PREVIEW: "adGroupSyncCandidatePreview",
  AD_GROUP_SYNC_STATUS: "adGroupSyncStatus",
  DYNAMIC_ROLE_ASSIGNMENTS: "dynamicRoleAssignments",
  DYNAMIC_ROLE_ASSIGNMENT_PREVIEW: "dynamicRoleAssignmentPreview",
  DYNAMIC_ROLE_ASSIGNMENT_STORED_PREVIEW: "dynamicRoleAssignmentStoredPreview",
  PERMISSIONS: "permissions",
  ROLE_DEFINITION_DETAILS: "roleDefinitionDetails",
  ROLE_DEFINITIONS: "roleDefinitions",
  ROLE_TEMPLATES: "roleTemplates",
  SECURITY_LOGS: "securityLogs",
  USER_SECURITY_LOGS: "userSecurityLogs",
  USER_CHANGES: "userChanges",
  USER_MAP_SYNC: "userMapSync",
  SKILLPANEL_VISIBILITY: "skillPanelVisibility",
  SKILLPANEL_CUSTOM_FIELDS: "skillPanelCustomFields",
  SKILLPANEL_DASHBOARDS: "skillPanelDashboards",
  SELF: "selfQuery",
  TEAMS: "teams",
  TEAM_IMPORTS: "teamImports",
  STRUCTURE_BATCH: "structureBatch",
  STRUCTURE_IMPORT_MODE: "structureImportMode",
  JOB_TITLES: "jobTitles",
  TEAM_TREE: "teamTree",
  TEAM_TREE_DETAILS: "teamTreeDetails",
  TEAM_TREE_MEMBERS: "teamTreeMembers",
  USER_CREATION: "userCreation",
  USER_CREATION_CONTEXT: "userCreationContext",
  USER_DETAILS: "userDetails",
  USER_IMPORTS: "userImports",
  USER_LIST: "userList",
  USER_PRODUCTS: "userProducts",
  TEMPORARY_ROLES: "temporaryRoles",
  ACCESS_REQUESTS: "accessRequests",
  INVITATION_STATUS: (invitationToken: string) => ["invitationStatus", invitationToken],
};
